import { CardHeader, CardHeaderTitle } from 'components/card/card-header';
import CardBody from 'components/card/CardBody';
import { useParams } from 'react-router-dom';
import Card from 'components/card/Card';
import messages from 'messages';
import RemoveIntegrationButton from 'containers/pages/persons/components/RemoveIntegrationButton';
import { FormattedMessage } from 'react-intl';

const IntegrationsCard = ({ person }) => {
  const { entityId } = useParams();

  return (
    <Card secondary>
      <CardHeader secondary>
        <CardHeaderTitle>Integrations</CardHeaderTitle>
      </CardHeader>
      <CardBody secondary>
        <ul className="c-card-integration__list">
          {Object.keys(person.integrations).map(key => {
            return (
              key && (
                <li key={key}>
                  {require(`assets/images/${key}.svg`) ||
                  require(`assets/images/${key}.png`) ? (
                    <img
                      src={
                        require(`assets/images/${key}.svg`) ||
                        require(`assets/images/${key}.png`)
                      }
                      alt={key}
                      title={key}
                    />
                  ) : (
                    <span
                      className="c-card__uppercased-bold-title u-margin-right-small"
                      style={{ width: '100%', maxWidth: 90 }}
                    >
                      {key}
                    </span>
                  )}
                  <RemoveIntegrationButton
                    entityId={entityId}
                    integration={key}
                    externalPersonMappingId={
                      person.integrations[key].externalPersonMappingId
                    }
                    person={person}
                  >
                    <span className="u-hidden-visually">
                      <FormattedMessage
                        {...messages.removeIntegration}
                        values={{
                          integration: key
                        }}
                      />
                    </span>
                  </RemoveIntegrationButton>
                </li>
              )
            );
          })}
        </ul>
      </CardBody>
    </Card>
  );
};

export default IntegrationsCard;
